"use client";

import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from "@tanstack/react-query";

import {
  updateAutomationsOverage,
  type AutomationsOverageInput,
} from "../../client/manager/automations";
import type { AutomationsEntitlementResponse } from "../../models/automations-entitlement";
import { automationsKeys } from "./automationsQueryKeys";

/** Saves the overage switch and limit, then writes the updated plan into the entitlement cache. */
export function useUpdateAutomationsOverage(
  comedianId: string
): UseMutationResult<
  AutomationsEntitlementResponse,
  Error,
  AutomationsOverageInput
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: AutomationsOverageInput) =>
      updateAutomationsOverage(comedianId, input),
    onSuccess: (entitlement) =>
      queryClient.setQueryData(
        automationsKeys.entitlement(comedianId),
        entitlement
      ),
  });
}
